import { Component, Input, OnInit } from '@angular/core';
import { CommonService } from '@services/common.service';
import { ChainEnum } from '@src/app/shared/types/wallet-chain.type';
import { MemeDashboardService } from '../../../meme-dashboard.service';
import { MemeToken, TokenMarketCapType } from '../../../meme-dashboard.type';
import { getTokenMarketCapType } from '../../../meme-dashboard.util';
interface DateRangeOption {
    label: string;
    value: string;
}

interface PercentageMap {
    small: number;
    medium: number;
    large: number;
}
@Component({
    selector: 'app-watchlist-smart-buys',
    templateUrl: './watchlist-smart-buys.component.html',
    styleUrls: ['./watchlist-smart-buys.component.less'],
})
export class WatchlistSmartBuysComponent implements OnInit {
    @Input() watchlistId: number;

    loading = false;

    dateRangeList: DateRangeOption[] = [
        { label: '1h', value: '1h' },
        { label: '4h', value: '4h' },
        { label: '1d', value: '1d' },
        { label: '7d', value: '7d' },
    ];

    dateRange = '1h';

    treemapList: { type: TokenMarketCapType; data: MemeToken[] }[] = [];

    percentageMap: PercentageMap = {
        large: 0.33,
        medium: 0.33,
        small: 0.33,
    };

    chain: any = ChainEnum.BASE;

    constructor(private memeDashboardService: MemeDashboardService, private commonService: CommonService) {}

    ngOnInit() {
        this.fetchData();
    }

    durationChange() {
        this.fetchData();
    }

    fetchData() {
        this.loading = true;

        this.memeDashboardService
            .getWatchlistTreemapData(this.watchlistId, this.dateRange, this.chain)
            .then(data => this.generateTreemapList(data.data.map(item => ({ ...item, list_type: 'smart_buy' }))))
            .catch(err => {
                if (err.message.code !== 400) {
                    this.commonService.errorMessageByResponse(err);
                }
            })
            .finally(() => (this.loading = false));
    }

    private generateTreemapList(data: MemeToken[]) {
        const largeData: MemeToken[] = [];
        const midData: MemeToken[] = [];
        const smallData: MemeToken[] = [];

        data.forEach(item => {
            const type = getTokenMarketCapType(item.market_cap);
            switch (type) {
                case 'large':
                    largeData.push(item);
                    break;
                case 'medium':
                    midData.push(item);
                    break;
                case 'small':
                    smallData.push(item);
                    break;
            }
        });

        this.treemapList = [
            ...(largeData.length ? [{ type: 'large', data: largeData }] : []),
            ...(midData.length ? [{ type: 'medium', data: midData }] : []),
            ...(smallData.length ? [{ type: 'small', data: smallData }] : []),
        ] as any;

        this.generatePercentageMap();
    }

    generatePercentageMap() {
        const r1 = this.treemapList.find(item => item.type === 'large')?.data.reduce((acc, cur) => acc + cur.watchlist_buy_amount_usd, 0) || 0;
        const r2 = this.treemapList.find(item => item.type === 'medium')?.data.reduce((acc, cur) => acc + cur.watchlist_buy_amount_usd, 0) || 0;
        const r3 = this.treemapList.find(item => item.type === 'small')?.data.reduce((acc, cur) => acc + cur.watchlist_buy_amount_usd, 0) || 0;
        const sum = r1 + r2 + r3;

        this.percentageMap = this.adjustPercentages({
            large: r1 / sum,
            medium: r2 / sum,
            small: r3 / sum,
        });
    }

    private adjustPercentages(original: PercentageMap): PercentageMap {
        const result = { ...original };
        const BASE_RATIOS = {
            large: 0.3, // 3
            medium: 0.4, // 4
            small: 0.3, // 3
        };

        // 找出哪些类型有数据（值大于0）
        const activeTypes = Object.entries(result)
            .filter(([_, value]) => value > 0)
            .map(([key]) => key as keyof PercentageMap);

        if (activeTypes.length === 0) return result;

        // 计算活跃类型的基础比例总和
        const totalBaseRatio = activeTypes.reduce((sum, type) => sum + BASE_RATIOS[type], 0);

        // 按比例分配
        activeTypes.forEach(type => {
            result[type] = BASE_RATIOS[type] / totalBaseRatio;
        });

        // 将没有数据的类型设置为0
        Object.keys(result).forEach(key => {
            if (!activeTypes.includes(key as keyof PercentageMap)) {
                result[key as keyof PercentageMap] = 0;
            }
        });

        return result;
    }
}
